import {useCallback, useRef} from 'react';

// waiting for useEvent from React.18
// see https://github.com/reactjs/rfcs/pull/220

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Fn = (...args: any[]) => void;

export function useEvent<F extends Fn>(fn: F): F {
	const fnRef = useRef<Fn>();

	fnRef.current = fn;

	return useCallback((...args: any[]) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		return fnRef.current?.(...args);
	}, []) as unknown as F;
}

export default useEvent;

export const useConstCallback = useEvent;
